module.exports = __webpack_public_path__ + "img/d308e49cfac46744a0a414ca1bf0e2e018b0a69b.dc580021.jpg";